import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { AdvancedMarker, InfoWindow } from "@vis.gl/react-google-maps";
import { Theme, UiLegacy } from "@silvertours/front-legacy-shared";
import { MarkerIconWrapper, MarkerWrapper } from "./CustomMarker.styles";
import { StationInfoBox } from "../StationInfoBox";
export var CustomMarker = function(param) {
    var children = param.children, deselect = param.deselect, id = param.id, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, position = param.position, select = param.select, setMarkerRef = param.setMarkerRef, station = param.station;
    var isMobile = Theme.useIsMobileTouchDevice();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AdvancedMarker, {
                ref: function(marker) {
                    return setMarkerRef && id && setMarkerRef(marker, id);
                },
                position: position,
                onClick: select,
                children: /*#__PURE__*/ _jsxs(MarkerWrapper, {
                    isSelected: isSelected,
                    children: [
                        /*#__PURE__*/ _jsx(MarkerIconWrapper, {
                            isSelected: isSelected,
                            children: /*#__PURE__*/ _jsx(UiLegacy.SvgIcon, {
                                name: "mapMarkerBox"
                            })
                        }),
                        children
                    ]
                })
            }, id),
            isSelected && !isMobile && /*#__PURE__*/ _jsx(InfoWindow, {
                position: position,
                pixelOffset: new google.maps.Size(0, -50),
                onCloseClick: deselect,
                children: /*#__PURE__*/ _jsx(StationInfoBox, {
                    closable: true,
                    station: station,
                    onClick: select,
                    selected: isSelected
                })
            })
        ]
    });
};
